export default __webpack_public_path__ + "static/media/play-video-circle.31aa96e8.svg";